import React from 'react'
import { MainBgImage } from '../../common'
import styled from 'styled-components'
import Image from '../../../images/OurCoaches/MainBgImage.jpg'
import { ButtonLink } from '../../common/Links'
import theme from '../../theme'
import { scroller } from 'react-scroll'
import Svg from '../../common/Svg'
import { arrowDownSecondary } from '../../common/Svg/elements'
import { H1 } from '../../GlobalStyles'

export const Subtitle = styled.div`
  width: 100%;
  color: ${p => p.theme.colors.white};
  font-size: 30px;
  font-weight: 400;
  text-align: center;
  @media screen and (min-width: 1025px) {
    font-size: 42px;
  }
`

export const Paragraph = styled.div`
  width: 100%;
  color: ${p => p.color || p.theme.colors.white};
  font-weight: 400;
  text-align: center;
  font-size: 20px;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  margin-top: 20px;
  @media (min-width: 1025px) {
    font-size: 27px;
    margin-top: 56px;
  }
`
export const BackgroundImageWrapper = styled.div`
  position: absolute;
  bottom: 50px;
  z-index: -1;
  padding: 0 40px;
  height: auto;
  text-align: center;
  @media screen and (min-width: 1025px) {
    min-width: 1440px;
    left: 50%;
    padding: 0px;
    transform: translateX(-50%);
  }
  .gatsby-image-wrapper {
    height: 100%;
  }
`

export const HeroButton = styled(ButtonLink)`
  margin-bottom: 50px;
  a {
    text-shadow: 0px 0px 0 rgba(0, 0, 0, 0.5);
    @media screen and (max-width: 350px) {
      padding: 11px 36px;
    }
  }
`

export const Title = styled.h2`
  color: ${p => p.theme.colors.white};
  font-weight: 800;
  letter-spacing: 1px;
  margin-bottom: 50px;
  font-size: 36px;
  text-align: center;
  text-shadow: 0 1px 1px ${p => p.theme.colors.black};
  text-transform: uppercase;
  @media screen and (min-width: 768px) {
    font-size: 48px;
  }
  @media screen and (min-width: 1025px) {
    font-size: 81px;
  }
`
export const CircleButton = styled.div`
  color: ${p => p.color || p.theme.colors.lighterGray};
  margin-top: 50px;
  cursor: pointer;
  &:hover {
    outline: none;
    text-decoration: none;
  }
`

export const HomeMainImage = () => {
  return (
    <MainBgImage height={840} position='flex-end' imageUrl={Image}>
      <BackgroundImageWrapper>
        <H1 marginBottom='52px'>The Future of Coaching</H1>
        <HeroButton
          url='https://pgacoach.lightspeedvt.com/'
          bgColor={theme.colors.gold}
          borderColor={theme.colors.gold}
          color={theme.colors.white}
          bgHoverColor={theme.colors.darkGold}
          borderHoverColor={theme.colors.darkGold}
          btnStyle='secondary'
          padding='11px 64px'
          aria-label='Get Started Here'
        >
          Get Started Here
        </HeroButton>
        <Paragraph>
          As Many as Possible. As Long as Possible. With the Best Experience
          Possible.
        </Paragraph>
        <CircleButton
          onClick={() =>
            scroller.scrollTo('adm', {
              duration: 800,
              delay: 0,
              smooth: 'easeInOutQuart'
            })
          }
          aria-label='adm'
        >
          <Svg d={arrowDownSecondary} width='37' />
        </CircleButton>
      </BackgroundImageWrapper>
    </MainBgImage>
  )
}

export default HomeMainImage
